import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "store/index";
import { selectQueryString } from "store/selectors/view";
import { viewStateActions } from "store/slices/view";

// Listen for changes to the query params via the back and forward buttons
// and update the view state if they differ from the current queryParams.
export const useNavigationObserver = () => {
  const dispatch = useAppDispatch();
  const queryString = useAppSelector(selectQueryString);

  useEffect(() => {
    const _handleURLChange = () => {
      const newQueryString = new URLSearchParams(window.location.search).toString();
      if (newQueryString === queryString) return;
      dispatch(viewStateActions.updateQueryParams(newQueryString));
    };
    window.addEventListener("popstate", _handleURLChange);
    window.addEventListener("pushstate", _handleURLChange);
    return () => {
      window.removeEventListener("popstate", _handleURLChange);
      window.removeEventListener("pushstate", _handleURLChange);
    };
  }, [dispatch, queryString]);
};
